export default __webpack_public_path__ + "static/media/logistics-management.b98ebe9f.svg";